<template>
    <div class="app">
          <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="#">
                <img class="navbar-brand-full" src="@/assets/img/logo.png" width="135" height="40">
                <!-- <img class="navbar-brand-minimized" src="@/assets/img/logo.png" width="30" height="30"> -->
            </b-link>
            <div v-if="isAdmin">
              <SidebarToggler class="d-md-down-none" display="lg" />
              <!-- <b-navbar-nav class="d-md-down-none">
                  <b-nav-item class="px-3">Dashboard</b-nav-item>
                  <b-nav-item class="px-3">Users</b-nav-item>
                  <b-nav-item class="px-3">Settings</b-nav-item>
              </b-navbar-nav> -->
            </div>
            <b-navbar-nav class="ml-auto mr-100">
                <b-nav-item class="d-md-down-none">                                    
                  <!-- <b-badge pill variant="danger"> </b-badge> -->
                  {{ this.$store.state.username }} / {{ this.$store.state.agencyName }}
                </b-nav-item>
                <HeaderDropdown/>
            </b-navbar-nav>
            <!-- <AsideToggler class="d-none d-lg-block" /> -->
          </AppHeader>

          <div class="app-body" style="background-color: #e4e5e6;">
            <div v-if="isAdmin">
              <AppSidebar fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="nav"></SidebarNav>
                <SidebarFooter/>
                <SidebarMinimizer/>
              </AppSidebar>
            </div>

            <main class="main">
               <breadcrumb :list="list"/>
               <div class="container-fluid">
                   <router-view></router-view>
               </div>
            </main>
            <!-- <AppAside fixed> -->
                <!--aside-->
                <!-- <AsidePanel/> -->
            <!-- </AppAside> -->
          </div>
          <PageFooter></PageFooter>
    </div>
</template>

<script>
import * as constants from '@/store/constants'
import nav from '@/_nav'
import nav_admin from '@/_nav_admin'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Breadcrumb } from '@coreui/vue'
import AsidePanel from '@/components/layout/AsidePanel'
import HeaderDropdown from '@/components/layout/HeaderDropdown'
import PageFooter from '@/components/layout/PageFooter.vue'

export default {
  name: 'full',
  components: {
    AppHeader,
    AsideToggler,
    AppSidebar,
    AppAside,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    AsidePanel,
    HeaderDropdown,
    PageFooter
  },
  data () {
    return {
      nav: (this.$store.state.permission === constants.ADMIN ? nav_admin.items : nav.items),
      isAdmin: (this.$store.state.permission === constants.ADMIN)
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/MainLayout.vue